import axios from 'axios';

export function getStatisticsSt(data) {
    return axios({
        method: 'post',
        url: '/api/v1/statistics/userStatistic',
        data,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}


// WEBPACK FOOTER //
// ./app/services/statistics/st.js